// extracted by mini-css-extract-plugin
export var cardsColumns = "index-module--cardsColumns--JNpRu";
export var catalogue = "index-module--catalogue--oOQax";
export var content = "index-module--content--OavEP";
export var shareBox = "index-module--shareBox--0q+pp";
export var shareContainer = "index-module--shareContainer--Lw7zQ";